import { render, staticRenderFns } from "./LanguageChoiceModal.vue?vue&type=template&id=36441150"
import script from "./LanguageChoiceModal.vue?vue&type=script&lang=js"
export * from "./LanguageChoiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports